/**
 * País elegido para el catálogo de Tours (F1) — Zustand local cache.
 *
 * El catálogo solo muestra experiencias que ARRANCAN en un país. Antes este
 * país venía de la región del dispositivo (useViewerCountry), pero la región
 * no es confiable (p. ej. un teléfono en Estados Unidos veía el catálogo de
 * SV vacío aunque la persona estuviera en El Salvador). Ahora el usuario
 * elige el país en la pantalla y se persiste en MMKV.
 *
 * El default es SV (país base de la operación). En logout se debe llamar
 * `reset()` para no heredar la elección de otro usuario.
 */

import { create } from 'zustand'
import { MMKV } from 'react-native-mmkv'
import { DEFAULT_COUNTRY_ISO2 } from '../data/countries'

let storage: MMKV
try {
  storage = new MMKV({ id: 'tago-tours-country' })
} catch {
  // SSR: MMKV constructor fails during static rendering
  storage = { getString: () => undefined, set: () => {}, delete: () => {} } as unknown as MMKV
}

const STORAGE_KEY = 'tours_catalog_country'

interface ToursCountryState {
  /** ISO 3166-1 alpha-2 del país seleccionado para el catálogo. */
  country: string
  setCountry: (country: string) => void
  reset: () => void
}

function load(): string {
  try {
    const raw = storage.getString(STORAGE_KEY)
    return raw ?? DEFAULT_COUNTRY_ISO2
  } catch {
    return DEFAULT_COUNTRY_ISO2
  }
}

export const useToursCountryStore = create<ToursCountryState>((set) => ({
  country: load(),
  setCountry: (country) => {
    set({ country })
    try {
      storage.set(STORAGE_KEY, country)
    } catch {
      // SSR or storage unavailable
    }
  },
  reset: () => {
    set({ country: DEFAULT_COUNTRY_ISO2 })
    try {
      storage.delete(STORAGE_KEY)
    } catch {
      // SSR or storage unavailable
    }
  },
}))
